import { createSlice } from '@reduxjs/toolkit';

interface ILoadingState {
  isLoading: boolean;
}

const initialState: ILoadingState = {
  isLoading: false,
};

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    REDUX_LOADING_TRUE: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    REDUX_LOADING_FALSE: (state) => {
      return {
        ...state,
        isLoading: false,
      };
    },
  },
});

export const { REDUX_LOADING_TRUE, REDUX_LOADING_FALSE } = loadingSlice.actions;

export const loadingReducer = loadingSlice.reducer;
